import {
    handleKeyboardDownEvent,
    keyboardInteractions
} from "../../../../react/core/utils/accessibilityHelpers";

// focus an element
const focusElement = function (elementId) {
    setTimeout(function () {
        const myEl = document.querySelector("#" + elementId);
        if (myEl) {
            myEl.focus();
        }
    });
};

//focus the first error in the list
const enableScreenReaderErrors = function (e) {
    e.preventDefault();
    const errorMessagesEl = document.querySelector("#screenReaderErrorMessages");
    errorMessagesEl.querySelector("a:first-child").focus();
};

// this function is called from an ng-click on an individual error message
// focus the input with an error
const focusOnErrorInput = function (e, elementId) {
    e.preventDefault();
    focusElement(elementId);
};

export default {
    focusElement: focusElement,
    enableScreenReaderErrors: enableScreenReaderErrors,
    focusOnErrorInput: focusOnErrorInput,
    handleKeyboardDownEvent,
    keyboardInteractions
};
